module.exports = __webpack_public_path__ + "img/Flag_of_Chad.8812ba91.svg";